import { Link } from 'react-router-dom';
import { FaEnvelope } from 'react-icons/fa';
import logo from '../images/common/Logo_Rond.png';
import { PLATFORM_META } from './socialPlatforms';
import useApi from '../hooks/useApi';

const col = [
  {
    title: 'Le Club',
    links: [
      { text: 'Notre Histoire',        to: '/club/histoire' },
      { text: 'Équipe dirigeante',     to: '/club/bureau' },
      { text: 'Agenda de la saison',   to: '/agenda' },
      { text: 'Règlement intérieur',   to: '/club/reglement' },
    ],
  },
  {
    title: 'Inscription',
    links: [
      { text: "Modalités",             to: '/inscription/modalite' },
      { text: "Pass'Sport",            to: '/inscription/passSport' },
      { text: "Coupon Sport ANCV",     to: '/inscription/couponSport' },
    ],
  },
  {
    title: 'Créneaux',
    links: [
      { text: 'Adulte',                to: '/creneaux/creneauxAdultes' },
      { text: 'Jeunes',                to: '/creneaux/creneauxJeunes' },
      { text: 'Catégories',            to: '/creneaux/CategoriesDefinition' },
      { text: 'Tarifs',                to: '/tarifs' },
    ],
  },
  {
    title: 'Contact',
    links: [
      { text: 'Coordonnées',           to: '/contact/contact' },
      { text: 'Formulaire',            to: '/contact/form' },
      { text: "Plan d'accès",          to: '/acces' },
      { text: 'FAQ',                   to: '/FAQ' },
    ],
  },
];

const Footer = () => {
  const { data: socialLinks } = useApi('social_links');
  const socialIcons = [
    ...socialLinks.filter(s => PLATFORM_META[s.platform]).map(s => ({ href: s.url, icon: PLATFORM_META[s.platform].icon })),
    { href: 'mailto:secretariatbceragny@gmail.com', icon: FaEnvelope },
  ];

  return (
  <footer className="bg-stone-950 text-white">
    <div className="max-w-6xl mx-auto px-5 pt-16 pb-10">
      {/* Top */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 mb-14">
        {/* Brand */}
        <div className="col-span-2 md:col-span-1">
          <Link to="/accueil" className="flex items-center gap-2.5 mb-5 group w-fit">
            <div className="w-9 h-9 shrink-0">
              <img src={logo} alt="BCE" className="w-full h-full object-contain drop-shadow-sm" />
            </div>
            <span className="font-bold text-lg text-white">BCE</span>
          </Link>
          <p className="text-sm text-stone-400 leading-relaxed mb-6 max-w-[200px]">
            Badminton Club Éragny — convivial et ouvert à tous depuis 1998.
          </p>
          <div className="flex gap-2">
            {socialIcons.map(({ href, icon: Icon }, i) => (
              <a
                key={i}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center text-stone-400 hover:bg-white/10 hover:text-white transition-all"
              >
                <Icon size={13} />
              </a>
            ))}
          </div>
        </div>

        {/* Nav columns */}
        {col.map((c, i) => (
          <div key={i}>
            <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-stone-500 mb-4">{c.title}</p>
            <ul className="space-y-2.5">
              {c.links.map((l, j) => (
                <li key={j}>
                  <Link to={l.to} className="text-sm text-stone-400 hover:text-white transition-colors">
                    {l.text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Bottom */}
      <div className="divider mb-6" style={{ borderColor: 'rgba(255,255,255,0.07)' }} />
      <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs text-stone-600">
        <p>&copy; {new Date().getFullYear()} Badminton Club Éragny. Tous droits réservés.</p>
        <p>Éragny-sur-Oise • Val d'Oise • France</p>
      </div>
    </div>
  </footer>
  );
};

export default Footer;
